import { render } from "./SetupView.vue?vue&type=template&id=5ac612d2&scoped=true"
import script from "./SetupView.vue?vue&type=script&lang=js"
export * from "./SetupView.vue?vue&type=script&lang=js"

import "./SetupView.vue?vue&type=style&index=0&id=5ac612d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac612d2"]])

export default __exports__